





import company from '@/store/types/company';
import {
  EnterpriceCommissions
} from '@/store/interfaces/company';

import commissionForm from './forms/commissions.vue';
import { mapGetters, mapMutations } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'EnterpriseComissions',
  components: {
    commissionForm,
  },
  data: () => ({
    commissions: {
      rate: 0,
      start_at: '',
      liquidation_period: '',
      minimum_order_value: 0,
      renewal: 'automatic',
    } as EnterpriceCommissions,
  }),
  created(): void {
    this.commissions = this.getNewCompanyParams.commission;
  },
  computed: {
    ...mapGetters({
      getNewCompanyParams: `companyModule/${company.getters.GET_NEW_COMPANY_PARAMS}`,
    }),
  },
  methods: {
    ...mapMutations({
      setCommissionsData: `companyModule/${company.mutations.SET_COMMISSIONS}`,
    }),
  },
  watch: {
    commissions: {
      deep: true,
      handler(vale: EnterpriceCommissions): void {
        setTimeout(() => {
          this.setCommissionsData(vale);
        }, 500);
      },
    },
  },
});
